import { render, staticRenderFns } from "./UsersOnFlowApprove.vue?vue&type=template&id=f255d64e&scoped=true"
import script from "./UsersOnFlowApprove.vue?vue&type=script&lang=ts"
export * from "./UsersOnFlowApprove.vue?vue&type=script&lang=ts"
import style0 from "./UsersOnFlowApprove.vue?vue&type=style&index=0&id=f255d64e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f255d64e",
  null
  
)

export default component.exports